var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdownOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 8.01208L21.3108 17.6993C21.6737 18.0768 22.2888 18.1023 22.6847 17.7562C23.0805 17.4102 23.1073 16.8235 22.7444 16.446L13.1892 6.50452C12.8826 6.18504 12.4536 6 12 6C11.5464 6 11.1174 6.18504 10.8103 6.50501L1.25559 16.446C0.892708 16.8235 0.919451 17.4101 1.31532 17.7562C1.7112 18.1023 2.32629 18.0768 2.68917 17.6993L12 8.01208Z",
  fill: "#32373C"
})));
export { SvgDropdownOpen as ReactComponent };
export default __webpack_public_path__ + "images/dropdown-open.svg";